const FOOD_THEME_CACHE_KEY = "delivery-huaraz:food-theme:v2";

export function readCachedThemeLoader() {
  try {
    const cached = JSON.parse(window.localStorage.getItem(FOOD_THEME_CACHE_KEY) || "null");
    return typeof cached?.loader === "string" ? cached.loader : "";
  } catch {
    return "";
  }
}

export function cacheThemeLoader(loader) {
  try {
    const cached = JSON.parse(window.localStorage.getItem(FOOD_THEME_CACHE_KEY) || "null") || {};
    window.localStorage.setItem(FOOD_THEME_CACHE_KEY, JSON.stringify({ ...cached, loader: String(loader || "") }));
  } catch {
    // The application still works when storage is disabled.
  }
}

export default function ThemeLoader({ src = "", label = "Cargando" }) {
  const hasCustomLoader = Boolean(String(src || "").trim());
  return (
    <main className="food-app food-theme-loading" aria-busy="true" aria-label={label}>
      <div className="food-theme-loading__content">
        <img
          className={hasCustomLoader ? "food-theme-loading__media is-custom" : "food-theme-loading__media"}
          src={hasCustomLoader ? src : "/assets/img/favicons/favicon-192x192.png"}
          alt="Delivery Huaraz"
        />
        {!hasCustomLoader && <span aria-hidden="true" />}
        <b className="food-theme-loading__label">{label}</b>
      </div>
    </main>
  );
}
